import { render, staticRenderFns } from "./ProductsLiabilityQuote.vue?vue&type=template&id=5c16d084"
import script from "./ProductsLiabilityQuote.vue?vue&type=script&lang=js"
export * from "./ProductsLiabilityQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports